import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE } from '../actions';

// Scalar group: a single CompanyAgencyApprovalModel (or null when never set).
const initialState = null;

const subCompanyAgencyApprovalsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE.GET_AGENCY_APPROVALS:
    case SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE.UPSERT_AGENCY_APPROVALS:
      return payload ?? initialState;

    case SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE.RESET_STATE:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default subCompanyAgencyApprovalsReducer;
